



import {Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {ConfigurationProfileHelper} from "@/components/device/configuration/ConfigurationProfileHelper";
import {UIConfiguration} from "@/components/device/configuration/types";
import {DeviceConfiguration, DeviceConfigurationSet, SelectOption} from "@/types/core";
import * as _ from "lodash";

@Component({})
export default class GenericControl extends Vue {

  protected configurationProfileHelper: ConfigurationProfileHelper | undefined;

  getIdsSortedByPosition():string[] {
    return this.configurationProfileHelper!.getIdsSortedByPosition();
  }

  isValueInRange(id:string, configuration: UIConfiguration):boolean {
    return this.configurationProfileHelper!.isValueInRange(id, configuration);
  }

  isChanged(id: string, current: any, newValue: any):boolean {
    if ( Array.isArray(current) ) {
      current = _.sortBy(current);
    }
    if ( Array.isArray(newValue) ) {
      newValue = _.sortBy(newValue);
    }
    const diff = !_.isEqual(current, newValue);
    if (diff) {
      this.configurationProfileHelper!.getUISections()[this.configurationProfileHelper!.deviceConfigurationProfile[id].sectionId as string].expanded = true;
    }
    return diff;
  }

  protected getValue(id: string, configuration: DeviceConfiguration[]):any {
    if (this.configurationProfileHelper!.deviceConfigurationProfile[id].type === 'option') {
      return this.extractConfigurationParameterAsSelectOption(
          this.configurationProfileHelper!.deviceConfigurationProfile[id].options as SelectOption[],
          configuration,
          parseInt(id, 16)).label;
    }
    if (this.configurationProfileHelper!.deviceConfigurationProfile[id].type === 'number') {
      return this.extractConfigurationParameterAsNumber(
          configuration,
          parseInt(id, 16));
    }
    if (this.configurationProfileHelper!.deviceConfigurationProfile[id].type === 'string') {
      return this.extractConfigurationParameterAsNumber(
          configuration,
          parseInt(id, 16));
    }
    if ( this.configurationProfileHelper!.deviceConfigurationProfile[id].type === 'checkbox-group') {
      return this.extractConfigurationParameterAsCheckBoxGroup(
          this.configurationProfileHelper!.deviceConfigurationProfile[id].options as SelectOption[],
          configuration,
          parseInt(id, 16));
    }
    return "unknown";
  }

  getNewConfigurationParameterAsSelectOption(optionsList: SelectOption[],
                                             configuration: DeviceConfigurationSet,
                                             parameterId: number):string {
    const newParam = _.find(configuration.newConf, param => param.id === parameterId);
    if (newParam) {
      return this.extractConfigurationParameterAsSelectOption(optionsList,
          configuration.newConf as DeviceConfiguration[],
          parameterId).value
    }
    return this.extractConfigurationParameterAsSelectOption(optionsList,
        configuration.current,
        parameterId).value
  }

  private extractConfigurationParameterAsNumber(configuration: DeviceConfiguration[], parameterId: number): number {
    const parameter = _.find(configuration, (parameter) => parameter.id === parameterId);
    if (parameter) {
      return parameter.value as number;
    }
    return 0;
  }

  private extractConfigurationParameterAsSelectOption(optionsList: SelectOption[],
                                              configuration: DeviceConfiguration[],
                                              parameterId: number):SelectOption {
    const parameter = _.find(configuration, (parameter) => parameter.id === parameterId);
    if (parameter) {
      return {
        label: this.getSelectOptionLabel(optionsList, parameter.value as string),
        value: parameter.value,
      } as SelectOption;
    }
    return {} as SelectOption;
  }

  private extractConfigurationParameterAsCheckBoxGroup(optionsList: SelectOption[],
                                                       configuration: DeviceConfiguration[],
                                                       parameterId: number):string[] {
    const parameter = _.find(configuration, (parameter) => parameter.id === parameterId);
    if (parameter) {
      return _.map(parameter.value as string[], value => {
        return this.getSelectOptionLabel(optionsList, value);
      });
    }
    return [];
  }

  private getSelectOptionLabel(listOfOptions: SelectOption[], value: string): string {
    const option = _.find(listOfOptions, (option) => option.value === value);
    return option ? option.label : 'not found';
  }

  protected toHex(d:number) {
    return  "0x" + ("0"+(d.toString(16))).slice(-2);
  }
}
